// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608310304/js/" + chunkId + "." + {"44":"9ea717bc","225":"9f35782e","481":"25027d6a","486":"0c66bbd0","770":"2fed4933"}[chunkId] + ".0.2752332330388443.chunk.js";
};